import React, { FC } from 'react';
import { useStyles } from '@wix/tpa-settings/react';
import { Text, TextTypography as TYPOGRAPHY } from '@wix/wix-ui-tpa/cssVars';
import stylesParams from '../../../../../stylesParams';
import { classes } from './ServiceNumber.st.css';

export type ServiceNumberProps = {
  index: number;
};

export const ServiceNumber: FC<ServiceNumberProps> = ({ index }) => {
  const styles = useStyles();
  const displayNumber = styles.get(stylesParams._serviceNumberDisplay);

  if (!displayNumber) {
    return null;
  }

  const formattedNumber = String(index + 1).padStart(2, '0') + '.';

  return (
    <div className={classes.root}>
      <Text className={classes.number} typography={TYPOGRAPHY.runningText}>
        {formattedNumber}
      </Text>
    </div>
  );
};
